(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1522],{

/***/ 2252:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/book-an-appointment",
      function () {
        return __webpack_require__(31338);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 31338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ book_an_appointment; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/layout/layout.tsx + 22 modules
var layout = __webpack_require__(16559);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(40782);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./src/api/http-client.ts
var http_client = __webpack_require__(55642);
// EXTERNAL MODULE: ./src/api/endpoints.ts
var endpoints = __webpack_require__(3557);
;// CONCATENATED MODULE: ./src/assets/images/banner-main.jpg
/* harmony default export */ var banner_main = ({"src":"/_next/static/media/banner-main.f7e2fea6.jpg","height":200,"width":1280,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAABAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAaEAEAAQUAAAAAAAAAAAAAAAAAAgQFNnOy/8QAFAEBAAAAAAAAAAAAAAAAAAAABP/EABgRAAIDAAAAAAAAAAAAAAAAAAABAzJx/9oADAMBAAIRAxEAPwC/sGMUeyXUgB46LBMl3rP/2Q=="});
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var react_redux_es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/store/slices/auth.ts
var auth = __webpack_require__(40034);
// EXTERNAL MODULE: ./src/store/index.ts + 1 modules
var src_store = __webpack_require__(89936);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Spinner.js
var Spinner = __webpack_require__(36968);
// EXTERNAL MODULE: ./src/lib/unbxd.ts
var unbxd = __webpack_require__(22236);
// EXTERNAL MODULE: ./src/styles/bookanappointment.module.scss
var bookanappointment_module = __webpack_require__(90358);
var bookanappointment_module_default = /*#__PURE__*/__webpack_require__.n(bookanappointment_module);
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(80008);
var moment_timezone_default = /*#__PURE__*/__webpack_require__.n(moment_timezone);
;// CONCATENATED MODULE: ./src/pages/book-an-appointment.tsx






















var Bookanappointment = function() {
    var getNextDate = function getNextDate() {
        var today = new Date();
        var tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        return tomorrow.toISOString().split("T")[0];
    };
    var router = (0,next_router.useRouter)();
    var authState = (0,react_redux_es/* useSelector */.v9)(auth/* selectAuth */.Hz);
    var dispatch = (0,src_store/* useAppDispatch */.T)();
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(false), loadings = ref1[0], setLoadings = ref1[1];
    var ref2 = (0,react.useState)([]), states = ref2[0], setStates = ref2[1];
    var ref3 = (0,react.useState)([]), cities = ref3[0], setCities = ref3[1];
    var ref4 = (0,react.useState)([]), stores = ref4[0], setStores = ref4[1];
    var ref5 = (0,react.useState)({}), store = ref5[0], setStore = ref5[1];
    var ref6 = (0,react.useState)(""), tncUrl = ref6[0], setTncUrl = ref6[1];
    var ref7 = (0,react.useState)([]), subPurpose = ref7[0], setSubPurpose = ref7[1];
    var ref8 = (0,react.useState)(""), subPurposeTitle = ref8[0], setSubPurposeTitle = ref8[1];
    var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            state: "",
            city: "",
            store_id: "",
            appointment_date: getNextDate(),
            appointment_time: "",
            appointment_purpose: "",
            sub_purpose: "",
            email: "",
            accept_tc: false
        },
        validationSchema: es/* object */.Ry({
            city: es/* string */.Z_().required("City is required"),
            store_id: es/* string */.Z_().required("Store is required"),
            state: es/* string */.Z_().required("State is required"),
            appointment_date: es/* date */.hT().min(new Date(), "Please select a future date").required("Appointment date is required"),
            appointment_time: es/* string */.Z_().required("Appointment time is required"),
            appointment_purpose: es/* string */.Z_().required("Appointment purpose is required"),
            email: es/* string */.Z_().email("Invalid email address").required("Email is required")
        }),
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
                var data, ref, ref1, ref2, ref3, basePath, ref4, ref5;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!loadings) {
                                _ctx.next = 2;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 2:
                            if (authState.user) {
                                _ctx.next = 5;
                                break;
                            }
                            dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(true));
                            return _ctx.abrupt("return");
                        case 5:
                            if (authState.user.billing_address) {
                                _ctx.next = 8;
                                break;
                            }
                            dispatch(auth/* authActions.setBillingModalOpen */.YV.setBillingModalOpen(true));
                            return _ctx.abrupt("return");
                        case 8:
                            if (!(tncUrl.length > 0 && !values.accept_tc)) {
                                _ctx.next = 11;
                                break;
                            }
                            (0,react_toastify_esm/* toast */.Am)("Please accept the terms and conditions.", {
                                type: "warning"
                            });
                            return _ctx.abrupt("return");
                        case 11:
                            if (!(subPurpose.length > 0 && !values.sub_purpose)) {
                                _ctx.next = 14;
                                break;
                            }
                            (0,react_toastify_esm/* toast */.Am)("Please specify the sub-purpose.", {
                                type: "warning"
                            });
                            return _ctx.abrupt("return");
                        case 14:
                            if (!(!authState.user.email && !values.email)) {
                                _ctx.next = 17;
                                break;
                            }
                            (0,react_toastify_esm/* toast */.Am)("Please enter email.", {
                                type: "warning"
                            });
                            return _ctx.abrupt("return");
                        case 17:
                            setLoadings(true);
                            _ctx.prev = 18;
                            _ctx.next = 21;
                            return http_client/* default.post */.Z.post(endpoints/* default.store_appointment.create */.Z.store_appointment.create(), {
                                store_id: values.store_id,
                                appointment_date: values.appointment_date,
                                appointment_time: values.appointment_time,
                                appointment_purpose: values.appointment_purpose,
                                sub_purpose: values.sub_purpose,
                                email: values.email
                            });
                        case 21:
                            data = _ctx.sent.data;
                            if (data.status === true) {
                                (0,react_toastify_esm/* toast */.Am)("Store Appointment Booked.", {
                                    type: "success"
                                });
                                if (window.smartech) {
                                    ;
                                    (0,unbxd/* unbxdCusEngTrackEvent */.$z)("store_appointment_booked", {
                                        date: moment_timezone_default()().format("DD-MM-YYYY")
                                    });
                                    window.smartech("identify", "".concat("91").concat((ref = authState.user) === null || ref === void 0 ? void 0 : ref.mobile));
                                    (0,unbxd/* unbxdCusEngTrackUser */.nV)({
                                        "pk^mobile": "".concat("91").concat((ref1 = authState.user) === null || ref1 === void 0 ? void 0 : ref1.mobile),
                                        email: values.email,
                                        NAME: (ref2 = authState.user) === null || ref2 === void 0 ? void 0 : ref2.name,
                                        GENDER: (ref3 = authState.user) === null || ref3 === void 0 ? void 0 : ref3.gender,
                                        SENCO_USER: "yes"
                                    });
                                }
                                setLoadings(false);
                            }
                            basePath =  false ? 0 : "/account/store-appointment";
                            window.location.href = basePath;
                            _ctx.next = 32;
                            break;
                        case 27:
                            _ctx.prev = 27;
                            _ctx.t0 = _ctx["catch"](18);
                            ;
                            (0,react_toastify_esm/* toast */.Am)((_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref4 = _ctx.t0.response) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.message) || "Something Went wrong", {
                                type: "warning"
                            });
                            setLoadings(false);
                        case 32:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        18,
                        27
                    ]
                ]);
            }));
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    var loadStates = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setLoading(true);
                        _ctx.next = 4;
                        return http_client/* default.get */.Z.get(endpoints/* default.stores.states */.Z.stores.states(), {
                            params: {
                                appointment: "yes"
                            }
                        });
                    case 4:
                        data = _ctx.sent.data;
                        if (data) {
                            setStates(data.data);
                            setLoading(false);
                        }
                        _ctx.next = 12;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        setLoading(false);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }));
        return function loadStates() {
            return _ref.apply(this, arguments);
        };
    }();
    var loadCities = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(state) {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setLoading(true);
                        _ctx.next = 4;
                        return http_client/* default.get */.Z.get(endpoints/* default.stores.cities */.Z.stores.cities(state), {
                            params: {
                                appointment: "yes"
                            }
                        });
                    case 4:
                        data = _ctx.sent.data;
                        if (data) {
                            setCities(data.data);
                            setLoading(false);
                        }
                        _ctx.next = 12;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        setLoading(false);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }));
        return function loadCities(state) {
            return _ref.apply(this, arguments);
        };
    }();
    var loadStores = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(state, city) {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setLoading(true);
                        _ctx.next = 4;
                        return http_client/* default.get */.Z.get(endpoints/* default.stores.stores */.Z.stores.stores(state, city), {
                            params: {
                                appointment: "yes"
                            }
                        });
                    case 4:
                        data = _ctx.sent.data;
                        if (data) {
                            setStores(data.data);
                            setLoading(false);
                        }
                        _ctx.next = 12;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        setLoading(false);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }));
        return function loadStores(state, city) {
            return _ref.apply(this, arguments);
        };
    }();
    var loadStore = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(store_code) {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setLoading(true);
                        _ctx.next = 4;
                        return http_client/* default.get */.Z.get(endpoints/* default.stores.store */.Z.stores.store(store_code), {
                            params: {
                                appointment: "yes"
                            }
                        });
                    case 4:
                        data = _ctx.sent.data;
                        if (data) {
                            setStore(data.data);
                            setLoading(false);
                        }
                        _ctx.next = 12;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        setLoading(false);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }));
        return function loadStore(store_code) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleLoginClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (authState.user) {
                            _ctx.next = 3;
                            break;
                        }
                        dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(true));
                        return _ctx.abrupt("return");
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleLoginClick() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        loadStates();
    }, []);
    var handleChange = function(name, value) {
        formik.setFieldValue(name, value);
        if (authState && authState.user && authState.user.name && !formik.values.email) {
            formik.setFieldValue("email", authState.user.email);
        }
        if (name === "state" && value) {
            loadCities(value);
            setCities([]);
            setStores([]);
            setStore({});
        } else if (name === "city" && value) {
            loadStores(formik.values.state, value);
            setStores([]);
            setStore({});
        } else if (name === "store_id" && value) {
            loadStore(value);
            setStore({});
        } else if (name === "appointment_purpose" && value) {
            if (store && store.purposes && store.purposes.length > 0) {
                var chield = store.purposes.filter(function(data) {
                    return data.id == value;
                });
                if (chield && chield.length > 0) {
                    if (chield[0].tnc) {
                        setTncUrl(chield[0].tnc_page);
                    } else {
                        setTncUrl("");
                    }
                    setSubPurpose(chield[0].children);
                    setSubPurposeTitle(chield[0].title);
                }
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (bookanappointment_module_default()).silver_booking_banner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: banner_main,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                children: [
                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(255, 255, 255, 0.5)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 9999
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                            animation: "grow",
                            role: "status"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (bookanappointment_module_default()).silver_booking_main,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (bookanappointment_module_default()).bg,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (bookanappointment_module_default()).silver_booking_bg,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "row",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "col-md-4 pb-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                children: "Select State"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                                                className: (bookanappointment_module_default()).custom_select,
                                                                id: "state",
                                                                name: "state",
                                                                onChange: function(e) {
                                                                    return handleChange("state", e.target.value);
                                                                },
                                                                value: formik.values.state,
                                                                children: states.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                            value: "",
                                                                            children: "--select your state--"
                                                                        }),
                                                                        states.map(function(value, index) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                value: value,
                                                                                children: value
                                                                            }, index);
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            formik.touched.state && formik.errors.state ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                className: "text-danger",
                                                                children: formik.errors.state
                                                            }) : null
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "col-md-4 pb-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                children: "Select City"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                                                className: (bookanappointment_module_default()).custom_select,
                                                                name: "city",
                                                                id: "cities",
                                                                onChange: function(e) {
                                                                    return handleChange("city", e.target.value);
                                                                },
                                                                value: formik.values.city,
                                                                children: cities.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                            value: "",
                                                                            children: "--select your city--"
                                                                        }),
                                                                        cities.map(function(value, index) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                value: value,
                                                                                children: value
                                                                            }, index);
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            formik.touched.city && formik.errors.city ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                className: "text-danger",
                                                                children: formik.errors.city
                                                            }) : null
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "col-md-4 pb-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                children: "Select Store"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                                                className: (bookanappointment_module_default()).custom_select,
                                                                name: "store_id",
                                                                onChange: function(e) {
                                                                    return handleChange("store_id", e.target.value);
                                                                },
                                                                value: formik.values.store_id,
                                                                children: stores.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                            value: "",
                                                                            children: "--select your store--"
                                                                        }),
                                                                        stores.map(function(value, index) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                value: value.store_code,
                                                                                children: value.store_name
                                                                            }, index);
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            formik.touched.store_id && formik.errors.store_id ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                className: "text-danger",
                                                                children: formik.errors.store_id
                                                            }) : null
                                                        ]
                                                    })
                                                ]
                                            }),
                                            store && Object.values(store).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "row",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "col-md-12",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (bookanappointment_module_default()).head,
                                                                children: "Store Details"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "border rounded p-3 bg-white w-100 mb-3",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "row",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "col-md-6",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                className: (bookanappointment_module_default()).text_p,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        children: "Name : "
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                        children: [
                                                                                            " ",
                                                                                            store.store_name,
                                                                                            " "
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "col-md-6",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                className: (bookanappointment_module_default()).text_p,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        children: "Code : "
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                        children: [
                                                                                            " ",
                                                                                            store.store_code,
                                                                                            " "
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "col-md-6",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                className: (bookanappointment_module_default()).text_p,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        children: "State : "
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                        children: [
                                                                                            " ",
                                                                                            store.store_state,
                                                                                            " "
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "col-md-6",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                className: (bookanappointment_module_default()).text_p,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        children: "City : "
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                        children: [
                                                                                            " ",
                                                                                            store.store_city,
                                                                                            " "
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "col-md-6",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                className: (bookanappointment_module_default()).text_p,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        children: "Pincode : "
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                        children: [
                                                                                            " ",
                                                                                            store.store_pin,
                                                                                            " "
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "col-md-6",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                className: (bookanappointment_module_default()).text_p,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        children: "Address : "
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                        children: [
                                                                                            " ",
                                                                                            store.store_address,
                                                                                            " "
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "col-md-12",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "row",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "col-md-4",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (bookanappointment_module_default()).form_group,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                htmlFor: "exampleInputEmail1",
                                                                                children: "Choose Date"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                                type: "date",
                                                                                className: (bookanappointment_module_default()).form_control
                                                                            }, formik.getFieldProps("appointment_date")), {
                                                                                min: getNextDate()
                                                                            })),
                                                                            formik.touched.appointment_date && formik.errors.appointment_date ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                className: "text-danger",
                                                                                children: formik.errors.appointment_date
                                                                            }) : null
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "col-md-4",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (bookanappointment_module_default()).form_group,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                htmlFor: "exampleInputEmail1",
                                                                                children: "Select time"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("select", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                                className: (bookanappointment_module_default()).custom_select
                                                                            }, formik.getFieldProps("appointment_time")), {
                                                                                children: store && store.timings && store.timings.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                            value: "",
                                                                                            selected: true,
                                                                                            children: "----Select Time----"
                                                                                        }),
                                                                                        store.timings.map(function(value, index) {
                                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                                value: value.id,
                                                                                                children: value.time
                                                                                            }, index);
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })),
                                                                            formik.touched.appointment_time && formik.errors.appointment_time ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                className: "text-danger",
                                                                                children: formik.errors.appointment_time
                                                                            }) : null
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "col-md-4",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (bookanappointment_module_default()).form_group,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                children: "Select Purpose of Appointment Booking"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                                                                className: (bookanappointment_module_default()).custom_select,
                                                                                name: "appointment_purpose",
                                                                                onChange: function(e) {
                                                                                    return handleChange("appointment_purpose", e.target.value);
                                                                                },
                                                                                value: formik.values.appointment_purpose,
                                                                                children: store && store.purposes && store.purposes.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                            selected: true,
                                                                                            children: "--Select Purpose of Appointment Booking--"
                                                                                        }),
                                                                                        store.purposes.map(function(value, index) {
                                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                                value: value.id,
                                                                                                children: value.title
                                                                                            }, index);
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            formik.touched.appointment_purpose && formik.errors.appointment_purpose ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                className: "text-danger",
                                                                                children: formik.errors.appointment_purpose
                                                                            }) : null
                                                                        ]
                                                                    })
                                                                }),
                                                                subPurpose.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "col-md-6",
                                                                    id: "sub_purpose",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (bookanappointment_module_default()).form_group,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                                children: [
                                                                                    "Select ",
                                                                                    subPurposeTitle,
                                                                                    " Purpose"
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                                className: (bookanappointment_module_default()).custom_select
                                                                            }, formik.getFieldProps("sub_purpose")), {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                                                                        selected: true,
                                                                                        children: [
                                                                                            "--Select ",
                                                                                            subPurposeTitle,
                                                                                            " Purpose--"
                                                                                        ]
                                                                                    }),
                                                                                    subPurpose.length > 0 && subPurpose.map(function(value, index) {
                                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                            value: value.id,
                                                                                            children: value.title
                                                                                        }, index);
                                                                                    })
                                                                                ]
                                                                            }))
                                                                        ]
                                                                    })
                                                                }) : tncUrl ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "col-md-12",
                                                                    id: "purpose_tnc",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                            type: "checkbox",
                                                                            style: {
                                                                                marginRight: "5px"
                                                                            },
                                                                            id: "purpose_tnc_accept",
                                                                            checked: formik.values.accept_tc,
                                                                            onChange: function(e) {
                                                                                return handleChange("accept_tc", e.target.checked);
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                                            htmlFor: "purpose_tnc_accept",
                                                                            children: [
                                                                                "Accept to our",
                                                                                " ",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    href: tncUrl ? tncUrl : "",
                                                                                    target: "_blank",
                                                                                    rel: "noreferrer",
                                                                                    style: {
                                                                                        color: "blue"
                                                                                    },
                                                                                    children: "Terms and Conditions"
                                                                                }),
                                                                                " ",
                                                                                "for Jewellery shopping through video call"
                                                                            ]
                                                                        })
                                                                    ]
                                                                }) : null
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            !authState.user && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "row",
                                                style: {
                                                    color: "#000",
                                                    marginBottom: "-25px",
                                                    marginTop: "10px"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "Please",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            style: {
                                                                color: "#FF3233",
                                                                cursor: "pointer"
                                                            },
                                                            onClick: handleLoginClick,
                                                            children: "Login"
                                                        }),
                                                        " ",
                                                        "to continue"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "row pt-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "col-md-4",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (bookanappointment_module_default()).form_group,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    children: "Name"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (bookanappointment_module_default()).input_group,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                        type: "text",
                                                                        className: (bookanappointment_module_default()).form_control,
                                                                        name: "name",
                                                                        style: {
                                                                            opacity: "0.8",
                                                                            backgroundColor: "#e6e7e8",
                                                                            color: "#000000",
                                                                            cursor: "not-allowed"
                                                                        },
                                                                        value: authState && authState.user && authState.user.name ? authState.user.name : "",
                                                                        disabled: true
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "col-md-4",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (bookanappointment_module_default()).form_group,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    children: "Mobile No."
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    type: "tel",
                                                                    className: "form-control",
                                                                    name: "mobile_no",
                                                                    style: {
                                                                        opacity: "0.8",
                                                                        backgroundColor: "#e6e7e8",
                                                                        color: "#000000",
                                                                        cursor: "not-allowed"
                                                                    },
                                                                    value: authState && authState.user && authState.user.mobile ? authState.user.mobile : "",
                                                                    disabled: true
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "col-md-4",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "col-md-12",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (bookanappointment_module_default()).form_group,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                        children: "Email"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                        type: "email",
                                                                        className: (bookanappointment_module_default()).form_control,
                                                                        style: authState && authState.user && authState.user.email ? {
                                                                            opacity: "0.8",
                                                                            backgroundColor: "#e6e7e8",
                                                                            color: "#000000",
                                                                            cursor: "not-allowed"
                                                                        } : {},
                                                                        onChange: function(e) {
                                                                            return formik.setFieldValue("email", e.target.value);
                                                                        },
                                                                        value: authState && authState.user && authState.user.email ? authState.user.email : formik.values.email,
                                                                        disabled: authState && authState.user && authState.user.email ? true : false
                                                                    }),
                                                                    formik.touched.email && formik.errors.email ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                        className: "text-danger",
                                                                        children: formik.errors.email
                                                                    }) : null
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "row justify-content-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "col-md-12 pt-1",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                            type: "button",
                                                            disabled: loadings,
                                                            onClick: formik.submitForm,
                                                            className: (bookanappointment_module_default()).buynow,
                                                            children: [
                                                                "BOOK",
                                                                " ",
                                                                loadings && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                                                    animation: "border",
                                                                    size: "sm"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "col-md-12 text-center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            id: "errorDiv"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var book_an_appointment = (Bookanappointment);


/***/ }),

/***/ 90358:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"silver_booking_banner":"bookanappointment_silver_booking_banner__0eBJP","head":"bookanappointment_head__4b1Nv","text_p":"bookanappointment_text_p__W4sfg","silver_booking_main":"bookanappointment_silver_booking_main__ax2Os","bg":"bookanappointment_bg__SQ9qz","silver_booking_bg":"bookanappointment_silver_booking_bg__O4Wag","custom_select":"bookanappointment_custom_select__D9TpM","form_control":"bookanappointment_form_control___gmPs","form_group":"bookanappointment_form_group__KbmZa","input_group":"bookanappointment_input_group__yJ3OQ","input_group_prepend":"bookanappointment_input_group_prepend__kjrhW","buynow":"bookanappointment_buynow__YrfYP","form_control_drop":"bookanappointment_form_control_drop__5Jy7J"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8523,4766,5675,9915,2640,3913,536,486,6646,1251,9774,2888,179], function() { return __webpack_exec__(2252); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);